function KBoardIcon({ width = 16, height = 16 }) {
    return (
        <svg
            width={`${width}`}
            height={`${height}`}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.00001 7.21519C8.82844 7.21519 9.50002 6.49545 9.50002 5.6076C9.50002 4.71975 8.82844 4 8.00001 4C7.17158 4 6.5 4.71975 6.5 5.6076C6.5 6.49545 7.17158 7.21519 8.00001 7.21519Z"
                fill="#5D636F"
            />
            <path
                d="M6.50001 9.99986C7.32844 9.99986 8.00002 9.28012 8.00002 8.39226C8.00002 7.50441 7.32844 6.78467 6.50001 6.78467C5.67158 6.78467 5 7.50441 5 8.39226C5 9.28012 5.67158 9.99986 6.50001 9.99986Z"
                fill="#5D636F"
            />
            <path
                d="M9.50001 9.99986C10.3284 9.99986 11 9.28012 11 8.39226C11 7.50441 10.3284 6.78467 9.50001 6.78467C8.67158 6.78467 8 7.50441 8 8.39226C8 9.28012 8.67158 9.99986 9.50001 9.99986Z"
                fill="#5D636F"
            />
            <path d="M1 8.37317L9.02012 1" stroke="#5D636F" strokeWidth="1.3" />
            <path d="M7.10229 13.9996L15.1224 6.62646" stroke="#5D636F" strokeWidth="1.3" />
            <path d="M7.10229 1L15.1224 8.37317" stroke="#5D636F" strokeWidth="1.3" />
            <path d="M1 6.62646L9.02012 13.9996" stroke="#5D636F" strokeWidth="1.3" />
        </svg>
    );
}

export default KBoardIcon;
